import store from '../store/index';
import { showNotification } from '../reducers/App'


export default class Fetch {
  static baseConfig = {};

  static get dispatch() {
    // Получаем dispatch напрямую из Redux store
    return store.dispatch;
  }

  static init(baseConfig) {
    this.baseConfig = baseConfig
  }

  static queryParamsToUrlParams = (params) => {
    let urlParams = '';
          
    for(let paramKey in params) {
      const value = params[paramKey];
  
      if(value !== undefined && value !== null) {
          urlParams = urlParams + `${paramKey}=${value}&`;
        }
      }
  
    return urlParams;
  }

  static async handleFetchErrors(response, url, method) {
    if(!response.ok) {
        const responseClone = response.clone();
        const error = `Fetch::Произошла ошибка по запросу: [${method}] ${url} Причина: ${response.statusText}`;   

        const responseData = await responseClone.json();
        let errorMessage = responseData.errorMsg.replace(/^Error:\s*/, '');

        if(errorMessage) {
          this.dispatch(showNotification({ isOpen: true, message: errorMessage }))
        }
  
        console.log(error)
        throw new Error(errorMessage)
    }
  }


  static async get(url, params, config = {}) {
    const fullConfig = {}
    Object.assign(fullConfig, this.baseConfig, config, { method: 'GET' });

    let fullUrl = url;

    const queryString = this.queryParamsToUrlParams(params);
    if (queryString) {
      fullUrl = url + '?' + queryString;
    }


    const response = await fetch(fullUrl, fullConfig);
    await this.handleFetchErrors(response, url, fullConfig.method);


    const responseData = await response.json();
    return responseData;
  }

  static async post(url, body, config = {}) {
    const fullConfig = {}

    Object.assign(fullConfig, this.baseConfig, config, { method: 'POST', body: body || null});

    const response = await fetch(url, fullConfig);  
    await this.handleFetchErrors(response, url, fullConfig.method);


    const responseData = await response.json();
    return responseData;
  }

  static async put(url, body, config = {}) {
    const fullConfig = {}
    Object.assign(fullConfig, this.baseConfig, config, { method: 'PUT', body: body || null});

    const response = await fetch(url, fullConfig);  
    await this.handleFetchErrors(response, url, fullConfig.method);


    const responseData = await response.json();
    return responseData;
  }

  static async delete(url, body, config = {}) {
    const fullConfig = {}
    Object.assign(fullConfig, this.baseConfig, config, { method: 'DELETE', body: body || null});

    const response = await fetch(url, fullConfig);  
    await this.handleFetchErrors(response, url, fullConfig.method);


    const responseData = await response.json();
    return responseData;
  }

}
